import { render, staticRenderFns } from "./TripartiteRecruit.vue?vue&type=template&id=5d4e0b82&scoped=true&"
import script from "./TripartiteRecruit.vue?vue&type=script&lang=js&"
export * from "./TripartiteRecruit.vue?vue&type=script&lang=js&"
import style0 from "./TripartiteRecruit.vue?vue&type=style&index=0&id=5d4e0b82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4e0b82",
  null
  
)

export default component.exports